//AgloPreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const AgloPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: "#f3f4f6",
            100: "#c5c9d3",
            200: "#979daf",
            300: "#68728c",
            400: "#3a4769",
            500: "#0c1c46",
            600: "#0a183c",
            700: "#081431",
            800: "#070f27",
            900: "#050b1c",
            950: "#030712"
        }
    }
});

export default AgloPreset;